import AntIcon from "@/components/icons/AntIcon";
import { Button, Card } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Permission } from "../../../../../common/security/enums";
import ComponentWithPermission from "../../../../auth/components/ComponentWithPermission";
import { CommissionsBatch, CommissionsUnit } from "../../types";
import { CommissionsUnitForm } from "../forms/CommissionsUnitForm";
import { CommissionsUnitTable } from "../tables/CommissionsUnitTable";

interface Props {
  batch: CommissionsBatch;
}

export const CommissionsBatchImportStep = ({ batch }: Props) => {
  const { t } = useTranslation();

  const [unitFormOpen, setUnitFormOpen] = useState<boolean>(false);
  const [unitToUpdate, setUnitToUpdate] = useState<CommissionsUnit>();

  const handleUpdateClick = (unit: CommissionsUnit) => {
    setUnitFormOpen(true);
    setUnitToUpdate(unit);
  };

  const handleFormCancel = () => {
    setUnitFormOpen(false);
    setUnitToUpdate(undefined);
  };

  return (
    <Card className="card-box">
      <ComponentWithPermission permissions={[Permission.COMMISSIONS_MANAGE]}>
        <div className={batch.commissionsUnits?.length > 0 ? "table-header-margin" : "margin-bottom-small"}>
          <Button type="primary" icon={<AntIcon type="plus" />} onClick={() => setUnitFormOpen(true)}>
            {t("commissions.batch.actions.addUnit")}
          </Button>
        </div>
      </ComponentWithPermission>

      <CommissionsUnitTable batch={batch} onUpdateClick={handleUpdateClick} />

      <CommissionsUnitForm batch={batch} unit={unitToUpdate} open={unitFormOpen} onFormCancel={handleFormCancel} />
    </Card>
  );
};
